// @@TODO: This should be moved to the 'lib' directory. It is not a component.
import { stringify } from 'csv-stringify/browser/esm'
import { ExportFilter } from '@/lib/table/table'

export const performExport = (exportData: ExportFilter[]) => {
  stringify(exportData, { quoted_string: true }, (err, data) => {
    if (!err) {
      console.info('data=', data)
      const blob = new Blob([data], { type: 'text/plain' })
      const url = URL.createObjectURL(blob)
      console.log('url=', url)
      const link = document.createElement('a')
      link.download = 'export.csv'
      link.href = url
      link.click()
    }
  })
}
